
import GridData from '@/sag-core/base/GridDataBase'
export default new GridData(
    {
        name: 'WGridData',
        columns: [
            // label 欄位顯示名稱
            // field 資料表欄位名稱
            {
                label: '員工工號', 
                field: 'Employee_WorkCode' 
            },
            {
                label: '員工名稱',
                field: 'Employee_CnName',
            },
            {
                label: '部門代號', 
                field: 'DepartmentId_Code' 
            },
            {
                label: '部門名稱',
                field: 'DepartmentId_Name',
            }
        ],
        columnsConfig: {
            tdClass: 'align-middle',
            filterOptions: {
                enabled: false,
                placeholder: `Search`
            }
        }
    }
)